import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import Security from "./SubFooter";
import "../../style/css/Platforminsight.css";


export default function PlatformInsight() {
const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);

  return (
    <>
      <Header />
      <div className="bg-darkgrey">
        <section className="aboutus bgStar pt-5 ">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center py-5">
                  <div
                    className="headingbox position-relative mb-3"
                    style={{ minHeight: "100px" }}
                  >
                    <div className="coins">
                      <img
                        src="images/coinsmall.png"
                        className="position-absolute start-0 bottom-0"
                        style={{ width: "70px" }}
                        alt=""
                      />
                      <img
                        src="images/coinlarge.png"
                        className="position-absolute end-0 top-0"
                        style={{ width: "90px" }}
                        alt=""
                      />
                    </div>
                    <Row className="justify-content-center">
                      <Col lg={9}>
                        <div className="position-relative d-inline-block text-left">
                          <div className="polygon" style={{ right: "30px" }}>
                            <img src="images/shape/polygon.png" alt="" />
                          </div>
                          <h1 className=" position-relative text-white mb-0">
                            INFI Community&nbsp;-&nbsp;
                            <span className="fw-normal">
                              Participation-Based Utility with the ©SbSe
                              Protocol.
                            </span>
                          </h1>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div className="position-relative mb-5">
                    <Row className="justify-content-center">
                      <Col lg={9}>
                        <h3 className="text-primary3 mb-3">
                          Decentralised. Transparent. Built for the Future.
                        </h3>
                        <p className="text-light-grey2">
                          At the core of our ecosystem lies the <strong className="text-white">INFI</strong> community engagement model, where
                          platform usage contributions are recognised through periodic redistributions. All
                          processes are managed via a fully decentralised and autonomous on-chain framework.
                        </p>
                        <div className="mt-5 mb-4">
                          <Row className="justify-content-center">
                            <Col lg={8}>
                              <div>
                                <img
                                  src="images/logos/sbseprotocol.png"
                                  width={`100%`}
                                  style={{ objectFit: "contain" }}
                                />
                              </div>
                            </Col>
                          </Row>
                        </div>
                        <h1 className="text-white">
                          <span className="fw-normal">What Powers the </span>{" "}
                          SbSe Protocol?
                        </h1>
                        <p className="text-light-grey2">
                          The ©SbSe Protocol is a next-generation adaptive system governed by dynamic smart
                          logic that manages key operational flows within the ecosystem.
                        </p>
                      </Col>
                    </Row>
                  </div>
                  <div className="position-relative ">
                    <Container>
                      <Row>
                        <Col lg={3} md={6} className="mb-5">
                          <div className="cardStyle3">
                            <Card className="p-3 cardBox">
                              <div>
                                <img
                                  src="images/ourfees/liquidity.svg"
                                  className="infi-icon "
                                  alt=""
                                />

                                <h5 className="mb-3 text-white fw-normal">
                                  Dynamic Value Flow
                                </h5>
                                <div>
                                  <p className="text-light-grey2">
                                    Facilitates seamless asset interactions across supported blockchain environments.
                                  </p>
                                </div>
                              </div>
                            </Card>
                          </div>
                        </Col>
                        <Col lg={3} md={6} className="mb-5">
                          <div className="cardStyle3">
                            <Card className="p-3 cardBox">
                              <div>
                                <img
                                  src="images/ourfees/delisting.svg"
                                  className="infi-icon "
                                  alt=""
                                />

                                <h5 className="mb-3 text-white fw-normal">
                                  Removal Model for Inactive Projects
                                </h5>
                                <div>
                                  <p className="text-light-grey2">
                                    A transparent 5% adjustment is applied, with no token retention — ensuring fair and
                                    community-driven processes.
                                  </p>
                                </div>
                              </div>
                            </Card>
                          </div>
                        </Col>
                        <Col lg={3} md={6} className="mb-5">
                          <div className="cardStyle3">
                            <Card className="p-3 cardBox">
                              <div>
                                <img
                                  src="images/ourfees/smarttrading.svg"
                                  className="infi-icon "
                                  alt=""
                                />

                                <h5 className="mb-2 text-white fw-normal">
                                  Smart Activity Adjustment Framework
                                </h5>
                                <p className="text-white mb-2">
                                  Base Rate: 0.01%
                                </p>
                                <div>
                                  <p className="text-light-grey2 mb-2">
                                    Adjusts dynamically based on network conditions such as interaction types and usage
                                    volumes on the INFI MultiChain Layer.
                                  </p>
                                  <p className="text-light-grey2">
                                    Events causing a significant network load may trigger a 3% stability buffer, designed to
                                    support platform balance.
                                  </p>
                                </div>
                              </div>
                            </Card>
                          </div>
                        </Col>
                        <Col lg={3} md={6} className="mb-5">
                          <div className="cardStyle3">
                            <Card className="p-3 cardBox">
                              <div>
                                <img
                                  src="images/ourfees/smartsecurities.svg"
                                  className="infi-icon "
                                  alt=""
                                />

                                <h5 className="mb-3 text-white fw-normal">
                                  SbSe Reserve Logic
                                </h5>
                                <div>
                                  <p className="text-light-grey2">
                                    Features a 48-hour response window for ecosystem-impacting interactions — an
                                    automated balancing function that maintains network stability.
                                  </p>
                                </div>
                              </div>
                            </Card>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="pt-0 pb-5">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="">
                  <div className="text-center position-relative mb-5">
                    <h1 className="text-white">
                      <span className="fw-normal">
                        Peer Engagement Mechanisms
                      </span>{" "}
                      {/* Reinvented */}
                    </h1>
                  </div>
                  <div className="position-relative ">
                    <Container>
                      <Row>
                        <Col lg={4} md={6} className="mb-5">
                          <div className="cardStyle3 text-center">
                            <Card className="p-3 cardBox">
                              <div>
                                <img
                                  src="images/ourfees/ultra.gif"
                                  className="infi-gificon"
                                  alt=""
                                />

                                <h5 className="mb-3 text-white fw-normal">
                                  Seamless Value Interactions
                                </h5>
                                <div>
                                  <p className="text-light-grey2">
                                    Point-to-point asset exchanges begin at minimal network rates, powered
                                    by an adaptive incentive architecture.
                                  </p>
                                </div>
                              </div>
                            </Card>
                          </div>
                        </Col>
                        <Col lg={4} md={6} className="mb-5">
                          <div className="cardStyle3 text-center">
                            <Card className="p-3 cardBox">
                              <div>
                                <img
                                  src="images/ourfees/earn.gif"
                                  className="infi-gificon"
                                  alt=""
                                />

                                <h5 className="mb-3 text-white fw-normal">
                                  Activity-Based Recognition
                                </h5>
                                <div>
                                  <p className="text-light-grey2">
                                    Participants may receive ecosystem utility credits for eligible on-platform
                                    actions — helping maintain system engagement and accessibility.
                                  </p>
                                  {/* <p className="text-light-grey2">
                                    Fully integrated reward logic keeps trading
                                    affordable, and in many cases, free of
                                    charge.
                                  </p> */}
                                </div>
                              </div>
                            </Card>
                          </div>
                        </Col>
                        <Col lg={4} md={6} className="mb-5">
                          <div className="cardStyle3 text-center">
                            <Card className="p-3 cardBox">
                              <div>
                                <img
                                  src="images/ourfees/selfbuilding.gif"
                                  className="infi-gificon"
                                  alt=""
                                />
                                <h5 className="mb-2 text-white fw-normal">
                                  Self-Evolving Architecture
                                </h5>
                                <div>
                                  <p className="text-light-grey2 mb-2">
                                    The SbSe Protocol operates through a self-adaptive, automated
                                    infrastructure — forming a scalable and resilient digital ecosystem. More
                                    than a protocol, it represents a shift toward autonomous, decentralised
                                    coordination in digital environments.
                                  </p>
                                </div>
                              </div>
                            </Card>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        {/* <section className="pt-0 pb-5">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="">
                  <div className="text-center position-relative mb-5">
                    <h2 className="text-white mb-3">Ecosystem at a Glance</h2>
                  </div>
                  <div>
                    <Card className="bg-transparent border-primary mb-5">
                      <Card.Body>
                        <Row>
                          <Col lg={3} className="">
                            <div className="p-3 text-center">
                              <div>
                                <div className="mb-3">
                                  <h1 className="text-primary3">248K+</h1>
                                </div>
                                <h5 className="mb-3 text-light-grey fw-normal">
                                  Wallets Created
                                </h5>
                              </div>
                            </div>
                          </Col>
                          <Col lg={3} className="">
                            <div className="p-3 text-center">
                              <div className="mb-3">
                                <h1 className="text-primary3">32K+</h1>
                              </div>
                              <h5 className="mb-3 text-light-grey fw-normal">
                                Monthly Active Users
                              </h5>
                            </div>
                          </Col>
                          <Col lg={3} className="">
                            <div className="p-3 text-center">
                              <div className="mb-3">
                                <h1 className="text-primary3">57+</h1>
                              </div>
                              <h5 className="mb-3 text-light-grey fw-normal">
                                Projects Launched
                              </h5>
                            </div>
                          </Col>
                          <Col lg={3} className="">
                            <div className="p-3 text-center">
                              <div className="mb-3">
                                <h1 className="text-primary3">120K+</h1>
                              </div>
                              <h5 className="mb-3 text-light-grey fw-normal">
                                Daily Transactions
                              </h5>
                            </div>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section> */}
        <section className="createanaccount position-relative  mt-0 overflow-hidden">
          <Container className=" position-relative">
            <Row className="justify-content-center align-items-center">
              <Col lg={12}>
                <div className="">
                  {/* <div className="text-center position-relative mb-5">
                    <h2 className="text-white mb-3">Market Performance</h2>
                  </div> */}
                  <div>
                    <Card className="bg-transparent border-0 ">
                      <Card.Body>
                        <Row>
                          <Col lg={6} className="">
                            {/* <div className="ps-lg-5 pt-5">
                              <h1 className="text-primary3 mb-3">$1.04554</h1>
                              <h2 className="text-white mb-3">
                                INFI Token Price:{" "}
                                <span className="text-success">Live</span>
                              </h2>
                              <p className="text-light-grey mb-2 fs-4">
                                Staking APY: 18–22%
                              </p>
                              <p className="text-light-grey fs-4">
                                TVL (Total Value Locked): $42.6M+
                              </p>
                            </div> */}
                          </Col>
                          <Col lg={6} className="">
                            <div className="handblock">
                              <div className="handanimation">
                                <img
                                  src="images/handCoin.png "
                                  className="chain"
                                />

                                <img
                                  src="images/handImg.png"
                                  className="handImg"
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="disclaimer pt-5 pb-5" id="disclaimer">
          <Container>
            <Row>
              <Col lg={12}>
                <div class="mb-4 pb-1">
                  <h2 className="fw-bold mb-3 text-white bg-head">Global Regulatory Disclaimer</h2>
                  <h4 className="mt-2 mb-3 text-white">Access and Use of the INFI MultiChain Ecosystem & SbSe Protocol</h4>
                  <p className="text-light-grey2">
                    The <span className="text-white">INFI Ecosystem,</span> including the <span className="text-white">INFI MultiChain CDEX Exchange,</span> operates as a <span className="text-white">fully
                      decentralized, non-custodial infrastructure</span> powered entirely by smart contracts and governed by
                    the autonomous, community-led <span className="text-white">SbSe Protocol.</span> There is no central administrator, financial
                    intermediary, or custodial authority.
                  </p>
                  <p className="text-light-grey2">
                    All user interactions — including staking, token swaps, governance voting, and liquidity
                    participation — are executed <span className="text-white">on-chain,</span> directly through users' self-custodies wallets. No centralized
                    control, account registration, or personal data collection is involved.
                  </p>
                </div>
                <div class="mb-4 pb-1">
                  <h5 class="text-white">CURRENT PLATFORM FUNCTIONALITY</h5>
                  <p class="text-light-grey mt-3 mb-2">The current platform includes features such as:</p>
                  <div>
                    <ul class="text-light-grey lh-lg">
                      <li>Smart contract-based token swaps (CDEX, OTC, and instant)</li>
                      <li>Governance through community voting</li>
                      <li>Access to protocol-driven rewards (non-guaranteed, claimable manually)</li>
                      <li>Optional participation in staking and liquidity mechanisms</li>
                    </ul>
                    <div>
                      <p class="text-light-grey mb-2">
                        The <strong className="text-white">INFI token</strong> is a <strong className="text-white">utility token,</strong> offering access to specific features within the SbSe ecosystem,
                        including:
                      </p>
                      <ul class="text-light-grey lh-lg">
                        <li>Governance participation</li>
                        <li>Smart contract–enabled access to protocol functions</li>
                        <li>Optional eligibility to claim incentives (e.g. DAI) based on ecosystem activity</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="mb-4 pb-1">
                  <h5 class="text-white">NO LICENSING OR REGISTRATION REQUIRED</h5>
                  <p class="text-light-grey mt-3 mb-2">This platform does <strong className="text-white">not offer regulated financial services,</strong> and no aspect of the <strong className="text-white">INFI token, INFI
                    MultiChain CDEX Exchange</strong> or <strong className="text-white">SbSe Protocol</strong> is intended to constitute:</p>
                  <div>
                    <ul class="text-light-grey lh-lg">
                      <li>A security</li>
                      <li>A financial instrument</li>
                      <li>A deposit or savings product</li>
                      <li>An investment contract</li>
                      <li>A collective investment scheme</li>
                    </ul>
                    <div>
                      <p class="text-light-grey mb-2">
                        The INFI token <strong className="text-white">does not</strong> represent equity, debt, dividends, profit-sharing, or legal claims of
                        ownership over any entity or treasury. It is <strong className="text-white">not</strong> designed or marketed as an investment vehicle.

                      </p>
                    </div>
                  </div>
                </div>

                <div class="mb-4 pb-1">
                  <h5 class="text-white">REWARDS & TOKEN DISTRIBUTIONS</h5>
                  <p class="text-light-grey mt-3 mb-2">Incentives and rewards (including DAI or other supported assets) are:</p>
                  <div>
                    <ul class="text-light-grey lh-lg">
                      <li><strong>Variable and non-guaranteed</strong></li>
                      <li><strong>Governed entirely by smart contract logic</strong></li>
                      <li><strong>Claimable only through manual user interaction</strong></li>
                      <li><strong>Subject to network activity, protocol usage, and staking conditions</strong></li>
                    </ul>
                    <div>
                      <p class="text-light-grey mb-2">
                        ⚠ No representations or warranties are made regarding returns, token price appreciation, or
                        passive income. Participation involves risk and should not be construed as a financial opportunity.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="mb-4 pb-1">
                  <h5 class="text-white">UPCOMING MODULES SUBJECT TO REGULATION</h5>
                  <p class="text-light-grey mt-3 mb-2">The following <strong className="text-white">future developments</strong> are <strong className="text-white">not yet live</strong> and <strong className="text-white">will only be made available after
                    securing applicable licenses or regulatory clearances</strong> where required:</p>
                  <div>
                    <ul class="text-light-grey lh-lg">
                      <li>INFI Digital Hybrid eWallet</li>
                      <li>INFI eBank (Web4 Finance Suite)</li>
                      <li>INFI Marketplace</li>
                      <li>INFI for Institutions (Enterprise Tools)</li>
                      <li>INFI Blockchain Infrastructure</li>
                      <li>SbSe Protocol expansions for tokenization and AI-powered finance</li>
                    </ul>
                    <div>
                      <p class="text-light-grey mb-2">
                        <strong className="text-white">No regulated services will be launched prior to full compliance</strong>  with relevant legal frameworks
                        in the respective jurisdictions.
                      </p>
                    </div>
                  </div>
                </div>

                <div class="mb-4 pb-1">
                  <h5 class="text-white">GLOBAL USER RESPONSIBILITY</h5>
                  <p class="text-light-grey mt-3 mb-2">By accessing or interacting with this platform, users <strong className="text-white">acknowledge and agree to the following : </strong> </p>
                  <div>
                    <ul className="text-light-grey2 lh-lg">
                      <li>
                        ✅ <strong className="text-white">Non-Custodial & Decentralized:</strong> All interactions are smart contract–based. Users remain in
                        full control of their wallets and assets.
                      </li>

                      <li>
                        ✅ <strong className="text-white">No Investment Advice or Guarantees:</strong> This platform provides no legal, financial, tax, or
                        investment advice. Users are solely responsible for understanding and managing their risk.
                      </li>

                      <li>
                        ✅ <strong className="text-white">Jurisdictional Restrictions:</strong> Use of the platform is prohibited where local laws restrict
                        participation in decentralized protocols or digital asset platforms. This includes, but is not limited
                        to:
                        <div className="mt-1">
                          <p><b className="text-white">United States, Canada, China, North Korea, Iran, Syria, Cuba,</b> or any territory subject to <b className="text-white">UN,
                            EU, UK, or US sanctions.</b></p>
                        </div>
                      </li>

                      <li>
                        ✅ <strong className="text-white">No Guarantees or Returns:</strong> All rewards, if any, are usage-based and distributed based on
                        ecosystem performance.<strong className="text-white">There is no passive income program or profit-sharing.</strong>.
                      </li>

                      <li>
                        ✅ <strong className="text-white">Use at Your Own Risk:</strong> Decentralized applications (dApps) carry inherent risks, including
                        smart contract bugs. Always verify smart contract addresses and interfaces before interacting.
                      </li>

                      <li>
                        ✅ <strong className="text-white">Community-Driven Governance:</strong> The protocol’s rules, upgrades, and operations are
                        determined through token-holder voting — not directed by a centralized team or entity.
                      </li>
                    </ul>
                    <div>
                      <p class="text-light-grey mb-2">
                        <strong className="text-white">No regulated services will be launched prior to full compliance</strong>  with relevant legal frameworks
                        in the respective jurisdictions.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="mb-4 pb-1">
                  <h5 class="text-white">⚠ LEGAL NOTICE</h5>
                  <p class="text-light-grey mt-3 mb-2">Participation in this protocol  <strong className="text-white">does not require </strong>any license or financial registration in any
                    jurisdiction, as the system is non-custodial, decentralized, and not operated by any legal entity
                    offering financial services. </p>

                  <p class="text-light-grey mb-2">
                    Nonetheless, <strong className="text-white"> participants are strongly encouraged to consult independent legal, financial, and
                      tax advisors</strong> to ensure compliance with local laws before engaging with the protocol.
                  </p>

                </div>


              </Col>
            </Row>
          </Container>
        </section>
        {/* <Security /> */}
      </div>
      <Footer />
    </>
  );
}
